const LOWER = "abcdefghijklmnopqrstuvwxyz";
const UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const NUMBERS = "0123456789";
const SYMBOLS = "!@#$%^&*_+-=";
const ALL = LOWER + UPPER + NUMBERS + SYMBOLS;

export function generatePassword(length = 16) {
  let pass =
    LOWER[Math.floor(Math.random() * LOWER.length)] +
    UPPER[Math.floor(Math.random() * UPPER.length)] +
    NUMBERS[Math.floor(Math.random() * NUMBERS.length)] +
    SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)];

  for (let i = 0; i < length - 4; i++) {
    pass += ALL[Math.floor(Math.random() * ALL.length)];
  }
  return pass
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("");
}
